import { CpfCnpjPipe } from './../../../shared/cpf-cnpj.pipe';
import { FormatPricePipe } from './../../../shared/format-price.pipe';
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import * as moment from 'moment';

import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { EventTypes } from './../../../shared/EventTypes';

import { PaymentFederalTaxes } from '../models/payment-federal-taxes';

import { PaymentFederalTaxesEventType } from './../payment-federal-taxes.event.type';
import { PaymentFederalTaxesService } from './../payment-federal-taxes.service';

import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { Auth } from '../../../autentication/Auth';
import { LimitsService } from '../../limits/limits.service';
import { ModalErrorEventType } from '../../../shared/modal-error/modal-error.event.type';
import { ThemeService } from '../../../shared/theme-service/theme.service';

@Component({
	selector: 'app-payment-confirmation-darf',
	templateUrl: './payment-confirmation-darf.component.html',
	styleUrls: ['./payment-confirmation-darf.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PaymentConfirmationDarfComponent implements OnInit, OnDestroy {
	@Input() paymentData: PaymentFederalTaxes;
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

	@Input() showBalance;
	@Output() showBalanceChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	imagesTax: Array<string> = [
		'assets/imgs/dashboard/ministe-rio-da-fazenda.png',
		'assets/imgs/dashboard/1200-px-logo-receita-federal-do-brasil-svg.png'
	];
	descriptionTax: String = `Ministério da Fazenda - Secretaria da Receita Federal <br>DARF (Documento de Arrecadação de Receitas Federais)`;

	public form: FormGroup;
	public formSignature: FormGroup;
	private view = '[data-component="payment-confirmation-darf"]';
	private today: number = Date.now();
	private viewHeight = 0;

	active = false;
	submited = false;
	scheduleError = false;
	disabled = false;
	isModal = true;

	isAttendant: boolean = false;

	constructor(private formBuilder: FormBuilder, private paymentService: PaymentFederalTaxesService,
		private limitsService: LimitsService, private themeService: ThemeService) {
		this.form = formBuilder.group({
			paymentDate: ['today', Validators.required],
			scheduleDate: [null],
		});
	}

	ngOnInit() {
		this.isAttendant = this.themeService.isAttendant();

		AppEventDispatcher.listen( PaymentFederalTaxesEventType.STEPS_DARF.CONFIRM_DARF, () => {
			this.active = true;
			this.setConfirmationData();
		});

		this.listenModal();
	}

	listenModal() {
		AppEventDispatcher.listen(ModalErrorEventType.MODAL.OK, () => {
			this.isModal = false;
			if (this.active) {
				this.send();
			}
		});

		AppEventDispatcher.listen(PaymentFederalTaxesEventType.MODAL.TRUE_MODAL, (data) => {
			this.isModal = data.data;
		});
	}

	show() {
		const interval = setInterval(() => {

			if ($(this.view).length > 0) {
				const containerHeight = this.getStepHeight();

				this.viewHeight = containerHeight;

				TweenMax.to('.steps-container', .8, { height: this.viewHeight, ease: Quint.easeOut});
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
				TweenMax.to('.buttons', .8, {delay: .8, bottom: 0, ease: Quint.easeOut});

				this.setSendListener();

				clearInterval(interval);
			}
			this.showBalanceChange.emit(false);
		}, 10);
	}

	setSendListener() {
		AppEventDispatcher.listen( PaymentFederalTaxesEventType.PAYMENT_FEDERAL_TAXES_SEND, () => {
			this.send();
		});
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	addAuthToken() {
		Auth.passToken = this.form.value.token ? this.form.value.token : '';
		Auth.assinaturaEletronica = this.form.value.eletronicSignature ? this.form.value.eletronicSignature : '';
	}

	readySend() {

		if (this.form.valid && this.formSignature.valid) {

			this.submited = false;
			this.disabled = true;

			this.preload(true);

			this.paymentData.password = this.formSignature.controls.eletronicSignature.value;
			if (this.form.controls.paymentDate.value === 'today') {

				this.paymentData.date = new Date();
				this.paymentData.dateLabel = moment(new Date()).format('DD/MM/YYYY');

			} else {

				this.paymentData.date = this.form.controls.scheduleDate.value;
				this.paymentData.dateLabel = moment(this.form.controls.scheduleDate.value).format('DD/MM/YYYY');

			}

			// delete this.paymentData.valueTotal;

			this.paymentService.sendPaymentDARF(this.paymentData).subscribe( data => {

				this.paymentData.payID = data.Retorno.PagamentoID;

				this.preload(true);
				this.submited = false;

				let time = 1;
				const timeLoader = setInterval(() => {
					time++;
				}, 1000);

				this.paymentService.passwordValidate(this.paymentData).subscribe( _data => {

					this.addAuthToken();

					this.paymentService.confirmation(this.paymentData).subscribe( d => {

						this.paymentData.message = d.Mensagem;
						this.paymentData.success = d.Sucesso;
						this.disabled = false;
						this.hide();
						this.preload(false);

					}, error => {

						this.paymentData.message = error.error.Mensagem;
						this.paymentData.success = error.error.Sucesso;
						this.disabled = false;
						this.hide();
						this.preload(false);

					});

				}, error => {
					this.disabled = false;
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
					AppEventDispatcher.dispatch(PaymentFederalTaxesEventType.ERROR, { step: PaymentFederalTaxesEventType.STEPS_DARF.CONFIRM_DARF });
					this.preload(false);

				});

			}, error => {
				this.disabled = false;
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				this.preload(false);

			});

		}

	}

	send() {
		this.submited = true;

		if (this.isModal) {

			this.preload(true);

			let time = 1;
			const timeLoader = setInterval(() => {
				time++;
			}, 1000);

			this.limitsService.getDataLimits().subscribe(data => {

				const listLimits = data[0];

				if (time > 3) {
					this.preload(false);
				} else {
					TweenMax.delayedCall(3 - time, () => {
						this.preload(false, 3 - time);
					});
				}
				clearInterval(timeLoader);

				$('[data-component="modal-error"]').appendTo('body');

				for (let i = 0; i < listLimits.length; i++) {
					const item = listLimits[i];
					if (item.typeLimit === 'DARF') {
						const currentTime = moment();
						const thisTime = item.timeLimit.split(' - ');
						const startTime = thisTime[0].replace('h', '');
						const endTime = thisTime[1].replace('h', '');

						const startMoment = moment(startTime, 'HH:mm');
						const endMoment = moment(endTime, 'HH:mm');
						const amIBetween = currentTime.isBetween(startMoment, endMoment);

						// se está dentro do horario
						if (amIBetween && item.utilDay) {
							this.readySend();
						} else {
							const dt = new Date();
							const nowTime = dt.getHours() + ':' + dt.getMinutes();

							const nowMoment = moment(nowTime, 'HH:mm');
							if (nowMoment < startMoment) {
								// Chamar modal apontando pro proximo horário
								AppEventDispatcher.dispatch(EventTypes.MODAL_ERROR.MODAL_ERROR,
									{
										show: true,
										title: 'Aviso!',
										text: `O horário limite para o pagamento deste tributo está excedido.
										O pagamento será efetivada no próximo dia útil. Deseja continuar?`,
										acceptButton: 'Entendi',
										hasCancelButton: false,
									}
								);
							} else {
								// Chamar modal apontanto pro próximo dia util
								AppEventDispatcher.dispatch(EventTypes.MODAL_ERROR.MODAL_ERROR,
									{
										show: true,
										title: 'Aviso!',
										text: `O horário limite para o pagamento deste tributo está excedido.
										O pagamento será efetivada no próximo dia útil. Deseja continuar?`,
										acceptButton: 'Entendi',
										hasCancelButton: false,
									}
								);
							}
						}
					}
				}

			}, error => {
				if (time > 3) {
					this.preload(false);
				} else {
					TweenMax.delayedCall(3 - time, () => {
						this.preload(false, 3 - time);
					});
				}
				clearInterval(timeLoader);

				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			});

		} else {
			if (this.isModal) {
				AppEventDispatcher.dispatch(PaymentFederalTaxesEventType.MODAL.TRUE_MODAL, { data: false });
			}
			this.readySend();
		}
	}

	setConfirmationData() {
		this.paymentData.confirmList.push(new ListItem('Nome:', this.paymentData.name, 'cls_mask'));
		this.paymentData.confirmList.push(new ListItem('Período de apuração:', moment(this.paymentData.refDate).format('DD/MM/YYYY')));
		const CpfCnpj = new CpfCnpjPipe();
		this.paymentData.confirmList.push(new ListItem('CPF/CNPJ:', CpfCnpj.transform(this.paymentData.cpfcnpj), 'cls_mask'));
		this.paymentData.confirmList.push(new ListItem('Código da receita:',
		this.paymentData.recipeCod + ' - ' + this.paymentData.recipeCodDescription, 'cls_mask'));
		this.paymentData.confirmList.push(new ListItem('Número de referência:', this.paymentData.refNumber, 'cls_mask'));
		this.paymentData.confirmList.push(new ListItem('Data de vencimento:', moment(this.paymentData.expDate).format('DD/MM/YYYY')));
		const FP = new FormatPricePipe();
		this.paymentData.confirmList.push(new ListItem('Valor principal:',  FP.transform(this.paymentData.valueDefault, false), 'cls_mask'));
		this.paymentData.confirmList.push(new ListItem('Valor da multa:', FP.transform(this.paymentData.valueTicket.toString(), false), 'cls_mask'));
		this.paymentData.confirmList.push(new ListItem(
			'Valor dos juros e/ou encargos:',
			FP.transform(this.paymentData.valueTax.toString(), false), 'cls_mask'
		));
		let valueTotal = this.paymentData.valueTotal
			.toString();
		valueTotal = valueTotal.replace(',', '.');
		this.paymentData.confirmList.push(new ListItem(
			'Valor total:', FP.transform(valueTotal, false), 'cls_mask'));

		this.show();
	}

	onSetSignatureForm(form: FormGroup) {
		this.formSignature = form;
		this.setForm.emit(this.formSignature);
	}

	checkDateOption(type) {
		if (type === 'schedule') {

			this.form.controls.scheduleDate.setValidators(Validators.required);
			this.form.controls.scheduleDate.updateValueAndValidity();

			if (moment().isAfter(this.form.controls.scheduleDate.value)) {
				this.scheduleError = true;
			} else {
				this.scheduleError = false;
			}
			this.isModal = false;
			this.form.controls.paymentDate.setValue('schedule');

		} else {
			this.isModal = true;
			this.form.controls.scheduleDate.clearValidators();
			this.form.controls.scheduleDate.setValue('');
		}
	}


	hide() {
		this.removeListeners();
		AppEventDispatcher.dispatch( PaymentFederalTaxesEventType.STEPS_DARF.RESULT_DARF, { show: true });
		AppEventDispatcher.dispatch( PaymentFederalTaxesEventType.BUTTONS, { show: true });

		TweenMax.to(this.view, .8, { delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
		}});
	}

	ngOnDestroy() {
		this.removeListeners();
	}

	removeListeners() {
		AppEventDispatcher.removeListener( PaymentFederalTaxesEventType.PAYMENT_FEDERAL_TAXES_SEND );
		AppEventDispatcher.removeListener( PaymentFederalTaxesEventType.STEPS_DARF.CONFIRM_DARF );
		AppEventDispatcher.removeListener(PaymentFederalTaxesEventType.MODAL.TRUE_MODAL);
		AppEventDispatcher.removeListener(ModalErrorEventType.MODAL.OK);
	}

	minDate() {
		return new Date();
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="payment-federal-taxes"] .content', show: active, delay: delay});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-federal-taxes/payment-confirmation-darf/payment-confirmation-darf.component.ts